import {
  AddCollaboratorsHistoryCertification,
  AddCollaboratorsHistoryCertificationResponse,
  GetCollaboratorsHistoryCertificationsResponse,
  UpdateCollaboratorsHistoryCertification,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryCertificationsService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryCertificationsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryCertificationsResponse>(
        `v1/collaborators/${collaboratorId}/history/certifications?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async add(
    collaboratorId: number,
    body: AddCollaboratorsHistoryCertification,
  ): Promise<AddCollaboratorsHistoryCertificationResponse> {
    const response = await httpClient.post<
      AddCollaboratorsHistoryCertification,
      AddCollaboratorsHistoryCertificationResponse
    >(`v1/collaborators/${collaboratorId}/history/certifications`, body);
    return response;
  },
  async update(
    collaboratorId: number,
    certificationId: number,
    body: UpdateCollaboratorsHistoryCertification,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/certifications/${certificationId}`,
      body,
    );
  },
  async delete(collaboratorId: number, certificationId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/certifications/${certificationId}`,
    );
  },
};

export default CollaboratorsHistoryCertificationsService;
